import {WlMultiLayer, WlLayer} from "./layers.component";

export * from './layers.component';
export default WlMultiLayer;

customElements.define('wl-multilayer', WlMultiLayer);
customElements.define('wl-layer', WlLayer);